"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryProviderDto = void 0;
class InventoryProviderDto {
    constructor(params) {
        this.name = "";
        this.dataSource = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.localPath = "";
        this.ftpUser = "";
        this.ftpPass = "";
        this.ftpServer = "";
        this.enabled = false;
        this.remotePath = "";
        this.hostImages = false;
        this.lastProcessingActivityOn = "";
        this.inventoryIdFromFilename = false;
        this.excludedFiles = "";
        this.lastProcessingSessionStarted = "";
        this.lastProcessingSessionEnded = "";
        this.imageHandler = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.name = params.name;
        this.dataSource = params.dataSource;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.localPath = params.localPath;
        this.ftpUser = params.ftpUser;
        this.ftpPass = params.ftpPass;
        this.ftpServer = params.ftpServer;
        this.enabled = params.enabled;
        this.remotePath = params.remotePath;
        this.hostImages = params.hostImages;
        this.lastProcessingActivityOn = params.lastProcessingActivityOn;
        this.inventoryIdFromFilename = params.inventoryIdFromFilename;
        this.excludedFiles = params.excludedFiles;
        this.lastProcessingSessionStarted = params.lastProcessingSessionStarted;
        this.lastProcessingSessionEnded = params.lastProcessingSessionEnded;
        this.imageHandler = params.imageHandler;
    }
}
exports.InventoryProviderDto = InventoryProviderDto;
//# sourceMappingURL=InventoryProviderDto.js.map